export default __webpack_public_path__ + "static/media/ordered.acc94983.svg";